import { gql } from '@/__generated__/gql';

export const LIST_ENTITY_TRANSACTIONS_QUERY = gql(`
  query InvestorDetailsActivityTabListEntityTransactions(
    $legalEntityIds: [String!]!
    $investmentId: String
    $page: Int!
    $rowsPerPage: Int!
    $sortBy: ListEntityCommitmentTransactionSortBy
    $order: String
    $search: String
    $transactionTypeFilter: [CommitmentTransactionType!]
  ) {
    ListEntityTransactions(
      legalEntityIds: $legalEntityIds
      investmentId: $investmentId
      page: $page
      rowsPerPage: $rowsPerPage
      sortBy: $sortBy
      order: $order
      search: $search
      transactionTypeFilter: $transactionTypeFilter
    ) {
      total
      page
      perPage
      investments {
        name
        id
      }
      filters {
        count
        value
        name
      }
      data {
        investmentId
        date
        strategy
        transactionType
        amount
        totalAmount
        distributionsToDate
        remainingCapital
        marketValue
        entityName
      }
    }
  }
`);
